<div *ngIf="buttonVisible">
    <button mat-icon-button color="primary" (click)="execute()">
        <mat-icon>{{ iconName }}</mat-icon>
    </button>
</div>
